import { P11Template } from '../../../common/enums/P11Template';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportKeyDetail } from '../models/ReportKeyDetail';

export class ReportKeyDetailMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportKeyDetail {
    let pkcs11Attributes: P11Template[] | null;
    let parsedKeyValue: object | null;
    let parsedKeyMetadata: object | null;

    try {
      parsedKeyValue = JSON.parse(data.valueJson);
    } catch {
      parsedKeyValue = null;
    }

    try {
      const parsed = JSON.parse(data.metadata);
      parsedKeyMetadata = parsed && Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      parsedKeyMetadata = null;
    }

    try {
      pkcs11Attributes = JSON.parse(data.pkcs11Attributes) as P11Template[];
    } catch {
      pkcs11Attributes = null;
    }

    const organizationKeyId = data.organizationKey?.id ? this.gqlIdEncoder.decode(data.organizationKey.id) : null;
    return new ReportKeyDetail(
      this.gqlIdEncoder.decode(data.id),
      data.shortDescription,
      data.operationSummary ?? '',
      parsedKeyValue,
      parsedKeyMetadata,
      organizationKeyId,
      data.source,
      data.hasPrivateKey,
      pkcs11Attributes
    );
  }
}
